import { isRecord } from './isRecord';
import { type ICreaterPayments } from '@/types/ICreaterPayments';

/**
 * Проверяет, что значение — аккаунт менеджера в ответах платежей и заявок на
 * возврат (`added_by`, `ordered_by`, `approved_by`).
 *
 * Проверяются поля, которыми пользуется интерфейс: идентификатор, имя и
 * фамилия. Остальные поля аккаунта у разных ручек различаются (см. Reference).
 *
 * @param value - значение из ответа бэка
 * @returns true, если значение можно показать как аккаунт
 */
export const isPaymentAccount = (value: unknown): value is ICreaterPayments =>
  isRecord(value) &&
  typeof value.id === 'number' &&
  typeof value.name === 'string' &&
  typeof value.surname === 'string';
